import React from 'react';

import { getCategoryNameWithCompany } from './ClientCategoryFormItem';

/**
 * Job role as a grid of tappable pills, for the sign-up step.
 *
 * Sixteen roles is small enough to show whole. A dropdown hides them behind an
 * inner scroll, and that inner scroll is what misbehaves on some Android
 * browsers; a grid only ever scrolls with the page. Two columns on a phone,
 * three from tablet up (App.scss, .category-pill-grid). Tapping the chosen
 * pill again clears it — the field stays optional.
 *
 * Grouped by venue so a bar worker is not hunting past Courier and Busker:
 * hospitality, then hair and beauty, then the rest, Other last.
 *
 * Form-compatible: antd's Form.Item injects value / onChange.
 */
export const CATEGORY_PILL_ORDER = [
  // hospitality
  'waiter', 'bartender', 'barista', 'hotel', 'porter',
  // hair and beauty
  'hair', 'barber', 'nails', 'beauty',
  // the rest
  'delivery', 'courier', 'taxi', 'tour', 'busker', 'charity',
  'other',
];

export default function CategoryPillGrid({
  value, onChange, isCompany = false, id,
}) {
  const pick = (code) => {
    if (onChange) onChange(value === code ? undefined : code);
  };

  return (
    <div className="category-pill-grid" role="radiogroup" id={id}>
      {CATEGORY_PILL_ORDER.map((code) => {
        const selected = value === code;
        return (
          <button
            key={code}
            type="button"
            role="radio"
            aria-checked={selected}
            data-code={code}
            onClick={() => pick(code)}
            className={`category-pill${selected ? ' category-pill--selected' : ''}`}
          >
            {getCategoryNameWithCompany({ categoryCode: code, isCompany })}
          </button>
        );
      })}
    </div>
  );
}
